import React from 'react';
export function MechanismSection() {
  return <section className="w-full bg-gradient-to-b from-lavender-light/20 to-white py-20 px-6 md:px-8 pt-[50px] pb-[50px]" data-id="element-190">
      <div className="max-w-5xl mx-auto" data-id="element-191">
        {/* Headline */}
        <div className="text-center mb-12" data-id="element-192">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-text mb-4" data-id="element-193">
            Conoce el Sistema 3×3
          </h2>
          <p className="text-xl md:text-2xl text-lavender-dark font-semibold" data-id="element-194">
            (tu brújula diaria en posparto)
          </p>
        </div>

        {/* 3 Columns */}
        <div className="grid md:grid-cols-3 gap-6 md:gap-8 mb-10" data-id="element-195">
          {/* Column 1: MAMÁ */}
          <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-lavender/20 text-center pt-[5px] pb-[5px]" data-id="element-196">
            <div className="mb-4 text-[54px]" data-id="element-197">🧠</div>
            <h3 className="font-bold text-text mb-3 text-[28px]" data-id="element-198">MAMÁ</h3>
            <p className="text-text/80 text-[18px]" data-id="element-199">
              Agua + snack + descanso.
              <br data-id="element-200" />
              <span className="font-semibold text-text text-[20px]" data-id="element-201">
                Tu cuerpo primero, sin negociar.
              </span>
            </p>
          </div>

          {/* Column 2: BEBÉ */}
          <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-lavender/20 text-center mt-[0px] mb-[0px] pt-[5px] pb-[5px]" data-id="element-202">
            <div className="mb-4 text-[54px]" data-id="element-203">👶</div>
            <h3 className="font-bold text-text mb-3 text-[28px]" data-id="element-204">BEBÉ</h3>
            <p className="text-text/80 text-[18px]" data-id="element-205">
              Alimentación + pañal + seguridad.
              <br data-id="element-206" />
              <span className="font-semibold text-text text-[20px]" data-id="element-207">
                Lo esencial, sin sobrecargarte.
              </span>
            </p>
          </div>

          {/* Column 3: CASA */}
          <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-lavender/20 text-center pt-[5px] pb-[5px]" data-id="element-208">
            <div className="mb-4 text-[54px]" data-id="element-209">🏠</div>
            <h3 className="font-bold text-text mb-3 text-[28px]" data-id="element-210">CASA</h3>
            <p className="text-text/80 text-[20px]" data-id="element-211">
              Reset mínimo de 10 min.
              <br data-id="element-212" />
              <span className="font-semibold text-text" data-id="element-213">
                Orden visual = paz mental.
              </span>
            </p>
          </div>
        </div>

        {/* Copy below columns */}
        <div className="max-w-2xl mx-auto text-center space-y-6" data-id="element-214">
          <p className="md:text-xl text-text/80 text-[20px]" data-id="element-215">
            Cada día del plan tiene estas 3 prioridades ya decididas por ti.{' '}
            <span className="font-semibold text-text" data-id="element-216">
              Solo sigues el guión.
            </span>
          </p>

          {/* Anchor phrase */}
          <div className="bg-sage/10 rounded-2xl p-6 md:p-8 border border-sage/30" data-id="element-217">
            <p className="md:text-2xl font-bold text-sage-dark text-[24px]" data-id="element-218">
              "Si hoy estás viva, alimentada y tu bebé está seguro: hoy fue
              suficiente."
            </p>
          </div>
        </div>
      </div>
    </section>;
}